export default __webpack_public_path__ + "static/media/battery-icon.14fc9bb3.svg";